import {Component, OnInit} from '@angular/core';
import {Locker, ResidentForSelect} from '../../../../types/data.types';
import {DirectoryService} from '../../../../services/directory.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {AbstractDetailedView} from '../abstract-detailed-view';
import {NgForm} from '@angular/forms/forms';

declare const toastr: any;

@Component({
    selector: 'locker-view',
    templateUrl: './locker-view.component.html'
})
export class LockerViewComponent extends AbstractDetailedView implements OnInit {
    title = 'Locker';
    data: Locker;
    buildingSelectIsDisabled = false;
    suites = [];
    residents = [];

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService
    ) {
        super(directoryService, api);
    }

    actionButtonIsNotAvailable() {
        return !(this.data.id && (this.data.isCanDelete || this.data.isCanEdit));
    }

    update(form: NgForm, formField) {
        const data: any = {};
        if(formField != 'rentedToBuilding' && formField != 'rentedToSuite' && formField != 'rentedToSuiteUser')
            data[formField] = form.value[formField];
        else {
            const suite = this.suites.find(s => s.id == form.value.suite);
            const resident = this.residents.find(s => s.id == form.value.suiteUser);
            data.extendedRentedTo = {
                building:  form.value.building,
                suite:     form.value.suite ? form.value.suite : undefined,
                suiteNumber: form.value.suite && suite ? suite.suiteNumber : (form.value.suiteNumber ? form.value.suiteNumber : undefined),
                suiteUser: form.value.suiteUser && form.value.suiteUser != '0' ? form.value.suiteUser : undefined,
                suiteUserName: form.value.suiteUser && resident ? resident.fullName : (form.value.suiteUserName ? form.value.suiteUserName : undefined),
            };
        }

        this.patch(form.value.id, data);
    }

    changeBuilding(buildingId: string, form) {
        form.controls['suite'].reset();
        form.controls['suiteUser'].reset();
        this.getSuites(+buildingId, null, form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId)
                    this.getResidents(suiteId, form);
                else if(suiteId === 0)
                    this.residents = [new ResidentForSelect(0, 'Other')];
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        form.controls['suiteUser'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['suiteUser'].setValue(0);
            setTimeout(() => {
                form.controls['suiteNumber'].reset();
                form.controls['suiteUserName'].reset();
                // this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) {
            this.residents = [new ResidentForSelect(0, 'Other')];
            return;
        }
        const url = `/v1/suite-users/g_emshort.json?expand=user&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(form.value.rentedToSuite !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(
                        item => (new ResidentForSelect(item.id, item.user.fullName, [], item.user.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    changeResident(residentId: number) {
        if (!+residentId)
            this.data.extendedRentedTo.suiteUserName = '';
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        if (!item.isCanEdit) return;
        this.setEditModeForAll(false);
        if(fieldName != 'rentedToBuilding' && fieldName != 'rentedToSuite' && fieldName != 'rentedToSuiteUser')
            item.formFields[fieldName].editMode = state;
        else {
            item.formFields.rentedToBuilding.editMode = state;
            item.formFields.rentedToSuite.editMode = state;
            item.formFields.rentedToSuiteUser.editMode = state;
            setTimeout(() => {
                if (state)
                    this.getSuites(this.data.extendedRentedTo.building, this.data.extendedRentedTo.suite, this.form);
            });
        }
    }
}






// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/locker-view/locker-view.component.ts